<app-entity-profile-card
  *ngIf="topic"
  [name]="topic.name"
  [picture]="topic.picture"
>
  <app-entity-follow-header
    profileTitle
    [name]="topic.name"
    [active]="isTopicSaved"
    [ignored]="isTopicIgnored"
    [allowIgnore]="true"
    [labels]="shortcutLabels"
    [activeLabel]="topicLabel"
    [isLoading]="isAddedingOrIsRemoving"
    (toggled)="handleSaveTopic(topic)"
    (ignoreToggled)="handleIgnoreTopic($event)"
    (labelToggled)="handleTopicLabel($event)"
  ></app-entity-follow-header>
  <ul
    class="entity-profile__contacts"
    profileContacts
    aria-label="Contact links"
  >
    <li *ngIf="topic.webSiteUrl">
      <a [href]="topic.webSiteUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-globe" aria-hidden="true"></i><span>Website</span>
      </a>
    </li>
    <li *ngIf="topic.twitterUrl">
      <a [href]="topic.twitterUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-twitter" aria-hidden="true"></i><span>X</span>
      </a>
    </li>
    <li *ngIf="topic.linkedInUrl">
      <a [href]="topic.linkedInUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-linkedin" aria-hidden="true"></i><span>LinkedIn</span>
      </a>
    </li>
    <li *ngIf="topic.financial">
      <a [href]="topic.financial" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-money-bill" aria-hidden="true"></i
        ><span>Financial</span>
      </a>
    </li>
  </ul>
</app-entity-profile-card>
